api = require('../0_def.coffee')

api.factory 'api/Practice/setting#factory', [
  'ksc.RestList',
  (RestList) ->
    contract =
      id: { type: 'number' }
      name: { type: 'string' }
      practiceId: { type: 'number' }
      value: { type: 'string' }


    ->
      new RestList
        cache: true
        endpoint:
          url: '/dashboard-calendar-ui/api/Practice/setting'
        record:
          contract: contract
          idProperty: 'name'
          url: '/dashboard-calendar-ui/api/Practice/setting/<id>'
]


api.service 'api/Practice/setting', [
  'api/Practice/setting#factory',
  (settingsFactory) ->
    service = settingsFactory()

    # entire response can be cached, no partial loads. Load right away.
    service.restLoad ->
# auto-process
      for item in service
        if item.name is 'calendar.time_zone'
          service.tz = item.value
        else if item.name is 'calendar.minute_increment'
          service.incrementMinute = Number item.value
          service.increment = item.value * 60

    service
]
